import React from "react";
import { Col, Container, Row } from "reactstrap";
import ProfileMain from "./components/ProfileMain";
import ProfileStats from "./components/ProfileStats";
import ProfileTodo from "./components/ToDo/ProfileTodo";
import ProfileOnBoarding from "./components/OnBoarding/ProfileOnBoarding";
import ProfileTabs from "./components/ProfileTabs";
import { useParams } from "react-router-dom";

function Calendar(props) {
  let { id } = useParams();
  return (
    <Container>
      <div className="profile">
        <Row>
          <Col md={12} lg={12} xl={4}>
            <Row>
              <ProfileMain id={id} />
              <ProfileStats id={id} />
            </Row>
          </Col>
          <Col md={12} lg={12} xl={8}>
            <Row>
              <Col md={6} lg={6} xl={6}>
                <ProfileTodo id={id} />
              </Col>
              <Col md={6} lg={6} xl={6}>
                <ProfileOnBoarding id={id} />
              </Col>
            </Row>
            <Row>
              <Col md={12} lg={12} xl={12}>
                <ProfileTabs id={id} />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default Calendar;
